module.exports = __webpack_public_path__ + "img/t-bold-icon.956cfb06.svg";